import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaEditComponent.vue?vue&type=template&id=5f7bd942"
import script from "./RsaConfigurazioneAttivitaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports